// extracted by mini-css-extract-plugin
export default {"buttons":"_2k4sbeuvicYsQ9uMBF_GnS"};